﻿import { ApiResourceFactory } from '../api.resource.factory'
import { GridModel, GridRequestModel, LocationModel, EntityModel, ResponseListModel, ResponseDeleteModel, DepositoryContentModel, OpResult, DevicesForChangeModel } from '../api.models'
import { LoginService } from './api.login.service'
import { IImportService } from './api.app.service'
import { CommonHelper } from '../../../helpers/common-helper'
import { OpLocationEquipment } from '../../../models/core/op-location-equipment-old'

export interface IDepositoriesService {
    saveDepository(req): ng.IPromise<LocationModel>
    getDepository(id, state?: any): ng.IPromise<LocationModel>
    getDepositoryContent(id: number): ng.IPromise<OpLocationEquipment[]>
    changeLocationEquipment(equipment: OpLocationEquipment[]): ng.IPromise<OpLocationEquipment[]>
    validateLocationEquipmentChanges(request: DevicesForChangeModel): ng.IPromise<OpLocationEquipment[]>
}

export class DepositoriesService implements IDepositoriesService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    getDepository(id, state: any = {}) {
        var get = this.apiResource.depositories.get
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state, false, rej.data.Message))
    }

    saveDepository(req): ng.IPromise<LocationModel> {
        return this.apiResource.depositories.save(req).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getDepositoryContent(id: number, state: any = {}): ng.IPromise<OpLocationEquipment[]> {
        var getDepositoryContent = this.apiResource.depositories['getDepositoryContent']
        state.request = getDepositoryContent({ id: id })
        return state.request.$promise.then((response: OpResult) => {
            var result = response.result.map(r => new OpLocationEquipment(r))
            CommonHelper.checkResultError(response)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    changeLocationEquipment(equipment: OpLocationEquipment[], state: any = {}): ng.IPromise<OpLocationEquipment[]> {
        var changeLocationEquipment = this.apiResource.depositories['changeLocationEquipment']
        state.request = changeLocationEquipment(equipment)
        return state.request.$promise.then((response: OpResult) => {
            var result = response.result.map(r => new OpLocationEquipment(r))
            var check = CommonHelper.checkResultError(response)
            if(check) return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    validateLocationEquipmentChanges(request: DevicesForChangeModel, state: any = {}): ng.IPromise<OpLocationEquipment[]> {
        var validateLocationEquipmentChange = this.apiResource.depositories['validateLocationEquipmentChange']
        state.request = validateLocationEquipmentChange(request)
        return state.request.$promise.then((response: OpResult) => {
            var result = response.result.map(r => new OpLocationEquipment(r))
            CommonHelper.checkResultError(response)
            var check = CommonHelper.checkResultError(response)
            if (check) return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }
}
